"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["DateTimeWithTimezone"] = "YYYY-MM-DD HH:mmZ";
    DateFormat["DateTimeWithTimezoneUTC"] = "YYYY-MM-DD HH:mm (Z UTC)";
    DateFormat["DateTime"] = "YYYY-MM-DD HH:mm";
    DateFormat["LogDateFormat"] = "YYYY-MM-DD HH:mm:ss ZZ";
    DateFormat["FullMonthNameNthDayFullYear"] = "MMMM Do YYYY";
    DateFormat["FullDateWithTimeAndDay"] = "dddd, MMMM Do @ h.mma";
    DateFormat["UTCOffset"] = "Z";
    DateFormat["DateOnly"] = "YYYY-MM-DD";
    DateFormat["TimeOnly"] = "HH:mm";
    DateFormat["YearOnly"] = "YYYY";
    DateFormat["TimeOnlyIn12Hour"] = "LT";
    DateFormat["DateWithMonth"] = "MMM DD, YYYY";
    DateFormat["DateWithMonthAndTime"] = "MMM DD, YYYY HH:mm a";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
//# sourceMappingURL=date-format.js.map